// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import ValidateAddressRequestModel from '../../model/validate-address-request-model';
import AddressValidationModel from '../../model/address-validation-model';

export default (service: Servicelayer) => ({
  /**  */
  async validateAddress(request: ValidateAddressRequestModel, config?: RequestConfig) {
    const requestDTO = ValidateAddressRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-validate-address'] ?? 'Address/Validate';
    const response = await service.get<any>(endpointPath, {
      query: {
        countryIso2: requestDTO.countryIso2,
        street: requestDTO.street,
        houseNumber: requestDTO.houseNumber,
        postalCode: requestDTO.postalCode,
        postalCodeAddition: requestDTO.postalCodeAddition,
        city: requestDTO.city,
        limit: requestDTO.limit,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(AddressValidationModel.toModel(dto));
  },
});
